/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'project': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" id="svgicon_project_a" d="M0 0h20v20H0z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_project_b" _fill="#fff"><use xlink:href="#svgicon_project_a"/></mask><path pid="1" d="M6.996 2.429c.29 0 .58.14.86.29h0l1.43 1.57h6.43c.71 0 1.14.57 1.14 1.14h0v2.57h1.86c.28 0 .71.14.86.43.14.29.28.71.14 1h0l-2.72 7.43c-.14.43-.57.71-1 .71h0-14.85c-.43 0-.86-.43-.86-.85h0V3.429c0-.57.43-1 1-1h0zm10.861 7.285H5.717l-2.86 6.29h12.71l2.29-6.29zM6.86 4H2v10l2.43-5.43c.14-.28.43-.57.86-.57h9.85V5.86H9c-.29 0-.57 0-.71-.29L6.86 4z" _stroke="#2B2D39" stroke-width=".3" _fill="#FFF" stroke-dasharray="0,0" mask="url(#svgicon_project_b)"/></g>'
  }
})
